import { FrequentServiceInterface } from '../models/frequent-service.interface';
import { FrequentServicesIdEnum } from '../models/frequent-services-id.enum';

export const frequentServices: Record<FrequentServicesIdEnum, FrequentServiceInterface> = {
  [FrequentServicesIdEnum.C2C]: {
    id: FrequentServicesIdEnum.C2C,
    icon: 'card-to-card',
    primaryColor: '#77A0FD',
    secondaryColor: '#2164FC',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.WALLET]: {
    id: FrequentServicesIdEnum.WALLET,
    icon: 'wallet-in',
    primaryColor: '#77A0FD',
    secondaryColor: '#2164FC',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.CREDIT]: {
    id: FrequentServicesIdEnum.CREDIT,
    icon: 'Credit',
    primaryColor: '#9E84EB',
    secondaryColor: '#6B47EB',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.BNPL]: {
    id: FrequentServicesIdEnum.BNPL,
    icon: 'bnpl',
    primaryColor: '#9E84EB',
    secondaryColor: '#6B47EB',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.TOPUP]: {
    id: FrequentServicesIdEnum.TOPUP,
    icon: 'simcard',
    primaryColor: '#FEB780',
    secondaryColor: '#FE8020',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.BUNDLE]: {
    id: FrequentServicesIdEnum.BUNDLE,
    icon: 'Network',
    primaryColor: '#FEB780',
    secondaryColor: '#FE8020',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.BILL]: {
    id: FrequentServicesIdEnum.BILL,
    icon: 'Receipt-bill',
    primaryColor: '#FEB780',
    secondaryColor: '#FE8020',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.CHARITY]: {
    id: FrequentServicesIdEnum.CHARITY,
    icon: 'charity-2',
    primaryColor: '#F7929A',
    secondaryColor: '#F03D4C',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.TRAFFIC_FINES]: {
    id: FrequentServicesIdEnum.TRAFFIC_FINES,
    icon: 'traffic-signal',
    primaryColor: '#81859C',
    secondaryColor: '#4C495F',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.TOLL]: {
    id: FrequentServicesIdEnum.TOLL,
    icon: 'highway',
    primaryColor: '#81859C',
    secondaryColor: '#4C495F',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.TAXI]: {
    id: FrequentServicesIdEnum.TAXI,
    icon: 'taxi-Car',
    primaryColor: '#FED080',
    secondaryColor: '#FEA034',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.WEALTH]: {
    id: FrequentServicesIdEnum.WEALTH,
    icon: 'bar-chart-upward',
    primaryColor: '#9CE5A7',
    secondaryColor: '#2FBE72',
    selected: false,
    logoType: 'icon',
  },
  // [FrequentServicesIdEnum.INSURANCE]: {
  //   id: FrequentServicesIdEnum.INSURANCE,
  //   icon: 'Insurance',
  //   primaryColor: '#7883D3',
  //   secondaryColor: '#3E4AA3',
  //   selected: false,
  //   logoType: 'icon',
  // },
  [FrequentServicesIdEnum.BARCODE_SCANNER]: {
    id: FrequentServicesIdEnum.BARCODE_SCANNER,
    icon: 'scan',
    primaryColor: '#77A0FD',
    secondaryColor: '#2164FC',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.PAYMENT_OF_INSTALLMENT]: {
    id: FrequentServicesIdEnum.PAYMENT_OF_INSTALLMENT,
    icon: 'Calendar',
    primaryColor: '#9E84EB',
    secondaryColor: '#6B47EB',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.INSTALLMENT_PURCHASE_WITH_CHECK]: {
    id: FrequentServicesIdEnum.INSTALLMENT_PURCHASE_WITH_CHECK,
    icon: 'document-copy',
    primaryColor: '#9E84EB',
    secondaryColor: '#6B47EB',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.MCI_MOBILE_BILL]: {
    id: FrequentServicesIdEnum.MCI_MOBILE_BILL,
    image: 'mci.png',
    selected: false,
    logoType: 'logo',
  },
  [FrequentServicesIdEnum.MTN_MOBILE_BILL]: {
    id: FrequentServicesIdEnum.MTN_MOBILE_BILL,
    image: 'mtn.png',
    selected: false,
    logoType: 'logo',
  },
  [FrequentServicesIdEnum.RIGHTEL_MOBILE_BILL]: {
    id: FrequentServicesIdEnum.RIGHTEL_MOBILE_BILL,
    image: 'rightel.png',
    selected: false,
    logoType: 'logo',
  },
  [FrequentServicesIdEnum.INVESTMENT_FUNDS]: {
    id: FrequentServicesIdEnum.INVESTMENT_FUNDS,
    icon: 'Chart-three-line',
    primaryColor: '#9CE5A7',
    secondaryColor: '#2FBE72',
    selected: false,
    logoType: 'icon',
  },
  // [FrequentServicesIdEnum.GOLD_FUNDS]: {
  //   id: FrequentServicesIdEnum.GOLD_FUNDS,
  //   icon: 'gold-Bag',
  //   primaryColor: '#9CE5A7',
  //   secondaryColor: '#2FBE72',
  //   selected: false,
  //   logoType: 'icon',
  // },
  [FrequentServicesIdEnum.MOLTEN_GOLD_FUNDS]: {
    id: FrequentServicesIdEnum.MOLTEN_GOLD_FUNDS,
    icon: 'gold-bag',
    primaryColor: '#9CE5A7',
    secondaryColor: '#2FBE72',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.REAL_ESTATE_INVESTMENT]: {
    id: FrequentServicesIdEnum.REAL_ESTATE_INVESTMENT,
    icon: 'Chart-three-line',
    primaryColor: '#9CE5A7',
    secondaryColor: '#2FBE72',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.CROWDFUNDING]: {
    id: FrequentServicesIdEnum.CROWDFUNDING,
    icon: 'crowd-funding',
    primaryColor: '#9CE5A7',
    secondaryColor: '#2FBE72',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.CAR_BODY_INSURANCE]: {
    id: FrequentServicesIdEnum.CAR_BODY_INSURANCE,
    icon: 'car-crash',
    primaryColor: '#7883D3',
    secondaryColor: '#3E4AA3',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.THIRD_PARTY_INSURANCE]: {
    id: FrequentServicesIdEnum.THIRD_PARTY_INSURANCE,
    icon: 'car',
    primaryColor: '#7883D3',
    secondaryColor: '#3E4AA3',
    selected: false,
    logoType: 'icon',
  },
  [FrequentServicesIdEnum.ELECTRICAL_DEVICES_INSURANCE]: {
    id: FrequentServicesIdEnum.ELECTRICAL_DEVICES_INSURANCE,
    icon: 'digital-device',
    primaryColor: '#7883D3',
    secondaryColor: '#3E4AA3',
    selected: false,
    logoType: 'icon',
  },
};
